const dropDownStyle = {
    item: {
        fontSize: 14,
        height: 38,
        minHeight: 38,
        lineHeight: '38px',
        padding: '0 3px'
    }
};


export default dropDownStyle;



// WEBPACK FOOTER //
// src/components/ui/dropdown-style.js